var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#122442",
    d: "M2.906 2.904c.917-.95 2.022-1.699 3.244-2.198 1.223-.5 2.536-.739 3.856-.702 1.316-.014 2.623.236 3.842.734 1.219.498 2.326 1.234 3.258 2.166.957.911 1.71 2.015 2.21 3.239.5 1.224.735 2.54.69 3.86.013 1.317-.237 2.624-.735 3.843-.498 1.219-1.234 2.327-2.165 3.258-.912.957-2.016 1.71-3.24 2.21-1.223.5-2.54.735-3.86.69-1.317.013-2.623-.237-3.843-.735-1.219-.498-2.326-1.234-3.257-2.165-.958-.912-1.711-2.016-2.211-3.24-.5-1.223-.735-2.54-.69-3.86-.022-1.319.223-2.628.722-3.848.498-1.22 1.24-2.327 2.179-3.252zm1.5 12.7c.722.758 1.59 1.362 2.553 1.775.963.412 2 .625 3.047.625 1.048.01 2.088-.199 3.052-.612s1.831-1.022 2.548-1.788c1.494-1.486 2.354-3.494 2.4-5.6.01-1.05-.199-2.089-.612-3.053s-1.022-1.831-1.788-2.547c-1.486-1.495-3.494-2.355-5.6-2.4-1.05-.01-2.089.198-3.053.611S5.122 3.637 4.406 4.404c-1.495 1.486-2.355 3.493-2.4 5.6 0 1.047.212 2.083.625 3.046.412.963 1.016 1.832 1.775 2.554zm6.1-10.7v5.2l4.5 2.7-.8 1.3-5.2-3.2v-6h1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHours);
export default __webpack_public_path__ + "static/media/icon-hours.d2065d9f.svg";
export { ForwardRef as ReactComponent };